import { CubbyState, IDLE_COLOR, LockerState } from '@barboxx/types';

export const DEFAULT_CUBBY_STATE: Omit<CubbyState, 'id'> = {
    back: 'closed',
    front: 'closed',
    orderId: null,
    occupied: false,
    color: IDLE_COLOR,
};

export const createLockerState = (
    numberOfCubbies: number,
    persistedState?: LockerState
) => {
    const lockerState = Array<Omit<CubbyState, 'id'>>(numberOfCubbies)
        .fill(DEFAULT_CUBBY_STATE)
        .reduce<LockerState>((state, current, index) => {
            const persistedData =
                persistedState && typeof persistedState[index] === 'object'
                    ? persistedState[index]
                    : {};
            return {
                ...state,
                [index]: {
                    id: index,
                    ...current,
                    ...persistedData,
                },
            };
        }, {} as LockerState);

    return lockerState;
};

export const getAvailableCubby = (
    lockerState: LockerState,
    preferredCubby?: null | number
) => {
    if (preferredCubby) {
        const pc = lockerState[preferredCubby];

        if (
            !pc.occupied &&
            pc.orderId === null &&
            pc.back === 'closed' &&
            pc.front === 'closed'
        ) {
            return preferredCubby;
        }
    }

    const availableCubby = Object.entries(lockerState).find(
        ([id, cubby]: [string, CubbyState]) =>
            !cubby.occupied &&
            cubby.orderId === null &&
            cubby.back === 'closed' &&
            cubby.front === 'closed'
    )?.[1];

    if (!availableCubby) {
        throw new Error('No available cubby');
    }

    return availableCubby.id;
};

type PartialLockerCubby = Partial<CubbyState> & { id: number };

export const updateLockerState = (
    lockerState: LockerState,
    lockerCubby: PartialLockerCubby
): LockerState => ({
    ...lockerState,
    [lockerCubby.id]: {
        ...lockerState[lockerCubby.id],
        ...lockerCubby,
    },
});
